import moment from 'moment';

export function TopicsTooltip() { }

TopicsTooltip.prototype.init = function (params: any) {
  const eGui = (this.eGui = document.createElement('div'));
  const color = params.color || 'white';
  if (!params.data) {
    eGui.classList.add('custom-tooltip');
    eGui.style.backgroundColor = color;
    const contentElement = document.createElement('div');
    contentElement.textContent = params.value == null ? '' : String(params.value);
    eGui.appendChild(contentElement);
    return;
  }

  let content = params.value;
  const topicName = params.data.name.length > 45 ? `${params.data.name.substring(0, 45)}...` : params.data.name;

  const columnId = params.column.getColId();
  if (columnId === 'synonyms' || columnId === 'antonyms') {
    if (content.length === 0) {
      return;
    }
    const header = columnId === 'synonyms' ? 'Synonyms terms' : 'Antonyms terms';
    const prefix = `<span class="tooltip-term-header">${header} for ${topicName}</span> <br />`;
    content = content.map((x: string) => `<span class="term">${x}</span>`).join('');
    content = prefix + content;
  }

  if (columnId === 'name' || columnId === 'definition' || columnId === 'comments') {
    content = `<span class="text">${content}</span>`;
  }

  if (columnId.endsWith('Score')) {
    const scoreName = params.colDef.headerTooltip;
    content = `${topicName}<br />${scoreName}: ${content}`;
  }

  if (columnId === 'updateDate') {
    content = moment(content).format('DD/MM/YYYY HH:mm');
  }

  eGui.classList.add('custom-tooltip');
  eGui.style.backgroundColor = color;
  eGui.innerHTML = `<div>${content}</div>`;
};

TopicsTooltip.prototype.getGui = function () {
  return this.eGui;
};
